import { Client } from '../clientFlowtypes'

interface State {
  data: Client;
}

const clientModule = {
  firestorePath: 'persons/{clientId}',
  firestoreRefType: 'doc', // or 'doc'
  moduleName: 'client',
  statePropName: 'data',
  namespaced: true, // automatically added

  // this object is your store module (will be added as '/clients')
  // you can also add state/getters/mutations/actions
  state: {},
  getters: {
    get: (state: State) => state.data,
  },
  mutations: {},
  actions: {
  },
}

export default clientModule
